import { useEffect, useState } from "react";
import { getPublicSiteSettings } from "@/lib/webContentApi";
import { SiteSettings } from "@/lib/webContentTypes";
import { getAprName, getPortalUrl } from "@/lib/runtime-config";

export const defaultSiteSettings: SiteSettings = {
  aprName: getAprName(),
  aprFullName: getAprName(),
  payUrl: "/pagar",
  portalUrl: getPortalUrl(),
  phone: "",
  email: "",
  address: "",
  schedule: "Lunes a Viernes: 09:00 - 14:00 hrs",
  whatsapp: "",
};

export function useSiteSettings(): SiteSettings {
  const [settings, setSettings] = useState<SiteSettings>(defaultSiteSettings);

  useEffect(() => {
    let mounted = true;
    getPublicSiteSettings()
      .then((value) => {
        if (mounted) {
          setSettings({ ...defaultSiteSettings, ...value });
        }
      })
      .catch(() => {
        // keep defaults
      });

    return () => {
      mounted = false;
    };
  }, []);

  return settings;
}
